import axios from "axios"

const route = '/physical_progress';

export default {
  namespaced: true,

  state: () => ({

  }),
  getters: {

  },
  mutations: {

  },
  actions: {
    index() {
      return axios.get(`${route}/physical_schedule`)
    },

    /**
     * carregar o cronograma físico do serviço
     */
    loadSchedule(context, id) {
      return axios.get(`${route}/physical_schedule/${id}`);
    },

    /**
     * Gerar o cronograma físico do serviço
     */
    generateSchedule(context, data) {
      return axios.post(`${route}/physical_schedule/generate_schedule`, data);
    },
    /**
     * gerar cronograma por etapa
     */
    generateScheduleStage(context, data) {
        return axios.post(`${route}/physical_schedule/generate_schedule_stage`, data);
    },

    /**
    * Salvar o cronograma físico do serviço
    */
    saveSchedule(context, data) {
      return axios.post(`${route}/physical_schedule/save_schedule`, data);
    },
    
    /**
    * Salvar o cronograma físico por stage
    */
    saveScheduleStage(context, data) {
      return axios.post(`${route}/physical_schedule/save_schedule_stage`, data);
    },


    /**
     * cronograma fisico analitico
     */
    indexAnalyticalSchedule(context , stages_ids) {
      return axios.get(`${route}/physical_schedule/analytical_schedule/index?stages_ids=${stages_ids}`);
    },

    /**
     * cronograma fisico sintético
     */
    indexSyntheticSchedule(context , stages_ids) {
      return axios.get(`${route}/physical_schedule/synthetic_schedule/index?stages_ids=${stages_ids}`);
    },

    /**
     * Exportar cronograma fisico analitico
     */
    getExportAnalyticalExcel(context , stages_ids) {
      return axios.get(`${route}/physical_schedule/analytical_schedule/export_excel?stages_ids=${stages_ids}`, {
        responseType: "blob",
      });
    },

    /**
     * Exportar cronograma fisico sintético
     */
    getExportsSyntheticExcel(context , stages_ids) {
      return axios.get(`${route}/physical_schedule/synthetic_schedule/export_excel?stages_ids=${stages_ids}`, {
        responseType: "blob",
      });
    },

    /**
     * carrega os itens do select stages
     */
    loadSelectStages() {
      return axios.get(`helper/get_stages_per_cost_current`);
    }

  }
}


